import { withMiddleware, ReactQuery } from './utils.mjs';

function createMutation(defaultOptions) {
  return Object.assign(withMiddleware(ReactQuery.useMutation, defaultOptions, 'mutations'), {
    getKey: () => defaultOptions.mutationKey,
    getOptions: () => defaultOptions,
    mutationFn: defaultOptions.mutationFn
  });
}

export { createMutation };
//# sourceMappingURL=createMutation.mjs.map
